// extracted by mini-css-extract-plugin
export default {"dnews":"Events_dnews__GYeYR","image":"Events_image__-p6fG","background":"Events_background__RUo11","month":"Events_month__8HkgR","date":"Events_date__1Ysmw"};